import { render, staticRenderFns } from "./EventFileUploader.vue?vue&type=template&id=b5c40db2&scoped=true"
import script from "./EventFileUploader.vue?vue&type=script&lang=js"
export * from "./EventFileUploader.vue?vue&type=script&lang=js"
import style0 from "./EventFileUploader.vue?vue&type=style&index=0&id=b5c40db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c40db2",
  null
  
)

export default component.exports